import React from "react";
import {connect} from "react-redux";
import {createDomainIncPanel} from "../../actions/domains";
import AccessItem from "../permissions/AccessItem";
import {Button, message, Modal, Space} from "antd";
import {displayErrors} from "../../libs/utils";

class DomainCreateInCpanel extends React.Component {
    state = {
        loading: false,
    };

    closeModal() {
        this.setState({
            loading: false,
        });

        this.props.close();
    }

    create() {
        this.setState({ loading: true });

        this.props.createDomainIncPanel(this.props.domain, () => {
            message.success('The domain has been added to cPanel successfully!');
            this.closeModal();
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ loading: false });
            }
        });
    }

    render() {
        let content = <p>Are you sure you wish to add the domain <b>{this.props.domainName}</b> in cPanel?</p>;

        if(this.state.loading) {
            content = <p>Please wait, adding the domain can take a couple of minutes...</p>;
        }

        return (
            <Modal
                centered
                title='Create Domain in cPanel'
                open={this.props.showModal}
                destroyOnClose={true}
                footer={<AccessItem scopes={['can_edit_domains']}>
                    <Space>
                        <Button disabled={this.state.loading}
                                onClick={() => this.closeModal()}>Cancel</Button>
                        <Button type='primary' loading={this.state.loading} disabled={this.state.loading}
                                onClick={() => this.create()}>Create</Button>
                    </Space>
                </AccessItem>}
                confirmLoading={this.state.loading}
                onCancel={() => this.closeModal()}>
                {content}
            </Modal>
        );
    }
}

export default connect(null, {createDomainIncPanel})(DomainCreateInCpanel);